import { Vue, Component } from 'vue-property-decorator'

@Component
export default class CreateCSS extends Vue {
    createCSS() {
        if(!this.event.layout || !this.event.layout.customCSS) return;
        const css = this.event.layout.customCSS;

        let arr = css.split(";");
        const newCss = arr.join(" !important;");
        let style = document.createElement("style");
        style.innerText = newCss;
        document.head.appendChild(style);
    }

    get event() {
        return this.$store.state.event;
    }
}